import axios from '@/requests';
import { LogMsgCategory, LogMsg, ErrLogMsgCategory, ErrLogMsg } from '@/store/modules/log/types';

export const logAPI = {
    async getLogCategoryByProjIdAndUid(projId: string, uid: string) {
        try {
            const res = await axios.get<LogMsgCategory[]>('/Log/getLogMsgCategoryListByProjIdAndUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getLogMsgLlistByProjIdAndUidAndRunId(projId: string, uid: string, runId: string) {
        try {
            const res = await axios.get<LogMsg[]>('/Log/getLogMsgLlistByProjIdAndUidAndRunId', { "projId": projId, "uid": uid, "runId": runId });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
}

export const errLogAPI = {
    async getErrLogMsgCategoryListByProjIdAndUid(projId: string, uid: string) {
        try {
            const res = await axios.get<ErrLogMsgCategory[]>('/ErrorLog/getErrLogMsgCategoryListByProjIdAndUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getErrLogMsgLlistByProjIdAndUidAndRunId(projId: string, uid: string, runId: string) {
        try {
            const res = await axios.get<ErrLogMsg[]>('/ErrorLog/getErrLogMsgLlistByProjIdAndUidAndRunId', { "projId": projId, "uid": uid, "runId": runId });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
}